<template>
  <div
    class="hm-simple-action-card mt-2"
    :class="{
      'hm-simple-action-card--active': active,
      'hm-simple-action-card--clickable': $attrs.click,
    }"
    @click="$emit('click')"
  >
    <HMIcon 
      v-if="prefixIcon"
      class="c-coral me-3"
      :class="{ 'fa-lg': iconSize === 'large' }"
      :icon="prefixIcon"
    ></HMIcon>
    <img v-if="prefixImage" :src="prefixImage" class="ms-1 me-3" />
    <div class="w-100">
      <slot>
        <h5 class="m-0 word-break">
          {{ title }}
        </h5>
      </slot>
    </div>
    <slot name="actions"></slot>
  </div>
</template>

<script lang="ts">
export default {
  name: 'HMSimpleActionCard',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    prefixIcon: {
      type: Array,
      default: null,
    },
    prefixImage: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    iconSize: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.hm-simple-action-card {
  display: flex;
  align-items: center;
  border: 1px solid $medium-gray;
  border-radius: $border-radius;
  padding: 0.5rem 1rem;
  cursor: pointer;
  min-height: 56px;
  &--active,
  &--clickable:hover {
    border-color: $coral;
  }
}
</style>
